/**
 * <DelayedSkeleton> — le squelette d'une vue qui charge, posé comme la page pose le sien (atom).
 *
 * Deux règles, écrites une fois pour toutes les vues : rien tant que le chargement n'a pas duré
 * le seuil d'apparition (`hooks/useSkeletonGate`, 150 ms — une réponse rapide ne fait rien
 * clignoter), puis le squelette sous SON `<SkeletonGroup>` : un seul balayage pour la vue.
 *
 * Il se monte quand la vue commence à charger et se démonte quand le contenu arrive :
 * `{loading ? <DelayedSkeleton>…</DelayedSkeleton> : contenu}`. `<PageTemplate skeleton>` s'en
 * sert pour une page ; une étape de feuille, une carte ou un pied de liste qui charge seul(e)
 * s'en sert directement.
 */
import React from "react"

import { useSkeletonGate } from "../../hooks/useSkeletonGate"
import { SkeletonGroup, type SkeletonGroupProps } from "./SkeletonGroup"

export function DelayedSkeleton(props: SkeletonGroupProps) {
    const shown = useSkeletonGate(true)

    return shown ? <SkeletonGroup {...props} /> : null
}
